import React, { Component } from 'react';
import { connect } from 'react-redux';

import { BasketCheckHelper } from '../../../../../../helpers/';
import { AddToBasketModal, Loader } from '../../../../../common/elements';
import { WebinarOverview, WebinarInfo, WebinarInnerInfo } from './elements';

import webinarsActions from '../../../../../../actions/training/webinars/webinars';
import purchaseActions from '../../../../../../actions/transactions/purchases';
import basketActions from '../../../../../../actions/transactions/basket';
import BackButton from "../../../../../dashboardNew/components/tools/BackButton";
import { PrismicDocumentHelper } from "../../../../../../helpers/prismicHelpers/PrismicHelpers"
import { WebinarsListHelper } from "../../../../../../helpers/prismicHelpers/prismic-custom-helpers/HomepageCardHelpers"


class WebinarItemFull extends Component {

    state = {
        webinar: '',
        webinarPrismic: ''
    }

    componentDidMount() {
        const { getCurrentWebinar, getProducts, params } = this.props;
        getCurrentWebinar(params.webinarId);
        getProducts();
    };

    componentWillMount() {
        this.getWebinars();
    }

    async getWebinars() {
        const id = this.props.params.webinarId
        const data = await PrismicDocumentHelper('my.single-webinar.uid', `${id}`, false, 'at')
        const webinarPrismic = WebinarsListHelper(data)
        this.setState({ webinarPrismic })
    }

    render() {
        const webinarPrismic = this.state.webinarPrismic && this.state.webinarPrismic.webinarsList[0];
        const productId = webinarPrismic && webinarPrismic.product_id
        const { webinar, originalProducts, addProductToBasket, basket } = this.props;
        const products = BasketCheckHelper.checkProductsInBasket(originalProducts, basket),
            webinarProduct = products && products.filter((product) => { return product.id === productId })[0];

        if (!webinar) {
            return <Loader />;
        }
        return (
            <article className="container-fluid interactive-webinars-inner-page theme-page-whole-blue darker">
                {webinarPrismic &&
                    <div className="image" style={{ backgroundImage: `url(${webinarPrismic.image})` }}></div>
                }
                <AddToBasketModal product={webinarProduct} addToBasket={addProductToBasket} />
                <div className="container">
                    <div className="row">
                        <div className="col-12 back-wrap">
                            <BackButton
                                title="Back to Webinars"
                                path="/training/interactive-webinars"
                            />
                        </div>
                        <WebinarInnerInfo webinar={webinar} webinarPrismic={this.state.webinarPrismic} />
                        <div className="webinar-info-wrapper">
                            <div className="webinar-info-wrapper-inner">
                                <WebinarOverview webinar={webinar} webinarPrismic={this.state.webinarPrismic} />
                                <WebinarInfo webinar={webinar} webinarPrismic={this.state.webinarPrismic} />
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        webinar: state.webinars.current_webinar,
        modules: state.webinars.current_webinar_modules,
        paging: state.webinars.pagination,
        basket: state.transactions.basket,
        originalProducts: state.transactions.products,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCurrentWebinar: (webinarId) => dispatch(webinarsActions.getCurrentWebinar(webinarId)),
        getCurrentWebinarModules: (webinarId) => dispatch(webinarsActions.getCurrentWebinarModules(webinarId)),
        addProductToBasket: (productId) => dispatch(basketActions.addProductToBasket(productId)),
        getProducts: (network) => dispatch(purchaseActions.getProducts(network)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WebinarItemFull);


// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/WebinarFullView.js